import {
  API_AUTH_LOGIN,
  API_AUTH_REFRESH,
  API_AUTH_USER,
  API_ALERTS_UN,
  API_ALL_INFO,
  API_ALERTS,
  API_DSSALERTS,
  API_INFOS,
  API_AREA_COUNTRIES,
  API_AREA_REGIONS,
  API_INFOS_GROUPED,
  API_INFO_TO_REVIEW,
  API_ALERTS_DETACH,
  API_ALERTS_ATTACH,
  API_DSSALERTS_DETACH,
  API_DSSALERTS_ATTACH,
  API_OSM_SEARCH
} from "./endpoint";

//
const CONTENT_TYPES = { json: "application/json; charset=utf8" };
const KEY_CURRENT_USER = "currentUser";

// const config = {server: 'https://api.cap.test', api: '/v1'}
const config = {
  server: process.env.REACT_APP_CAP_HOST,
  api: process.env.REACT_APP_CAP_VAPI
};
const serverApi = `${config.server}${config.api}`;

let unauthorizedHandler = null;
let refreshErrorHandler = null;
let refreshPromise = null;

export const setUnauthorizedHandler = handler => {
  unauthorizedHandler = handler;
};

export const setRefreshErrorHandler = handler => {
  refreshErrorHandler = handler;
};

/**
 * Description DRF user authentication by JWT
 * @param {string} username
 * @param {string} password
 * @return {object} user property
 */
export const userAuth = async (username, password) => {
  const options = {
    method: "POST",
    headers: { "Content-Type": CONTENT_TYPES.json },
    body: JSON.stringify({ username, password })
  };
  const response = await fetchApi(`${serverApi}${API_AUTH_LOGIN}`, options);

  if (response.access && response.refresh) {
    const user = await fetchApi(`${serverApi}${API_AUTH_USER}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${response.access}`,
        "Content-Type": CONTENT_TYPES.json
      }
    });

    if (!user.username) return { auth: false, errors: user };

    user.json_token = response.access;
    user.refresh_token = response.refresh;
    return {
      auth: true,
      username: user.username,
      errors: null,
      data: user
    };
  }
  return { auth: false, errors: response };
};

/**
 * Description get all data form combo form
 * @param {object} user
 * @return {object} allData values
 */
export const getAllData = async user => {
  const { error, options } = setOptions(user);
  if (error) return { erros: error };
  try {
    const allInfo = await Promise.all(
      API_ALL_INFO.map(url => fetchApi(`${serverApi}${url}`, options))
    );
    const alerts = { results: [] }; // await fetchApi(`${serverApi}${API_ALERTS_UN}`, options);
    /*
    const infosGroupedUN = await fetchApi(
      `${serverApi}${API_INFOS_GROUPED}?status=UN`,
      options
    );
    */
    return {
      errors: null,
      alerts,
      info: allInfo,
      apiInfo: API_ALL_INFO
      // infosGroupedUN
    };
  } catch (error) {
    return { errors: error, alerts: null, info: null, infosGroupedUN: null };
  }
};

export const getAlerts = async (user, params = "") => {
  const { error, options } = setOptions(user);
  if (error) return { erros: error };
  const item = await fetchApi(`${serverApi}${API_ALERTS}${params}`, options);
  return item;
};

export const getDSSAlerts = async (user, params = "") => {
  const { error, options } = setOptions(user);
  if (error) return { erros: error };
  const item = await fetchApi(`${serverApi}${API_DSSALERTS}${params}`, options);
  return item;
};

export const getAllUnassigned = async user => {
  const { error, options } = setOptions(user);
  if (error) return { erros: error };
  const item = await fetchApi(`${serverApi}${API_ALERTS_UN}`, options);
  return item;
};

export const addNewInfo = async (user, data) => {
  const { error, options } = setOptions(user, "POST", data);
  if (error) return { erros: error };
  const item = await fetchApi(`${serverApi}${API_INFOS}`, options);
  return item;
};

export const addNewAlert = async (user, data) => {
  const { error, options } = setOptions(user, "POST", data);
  if (error) return { erros: error };
  const item = await fetchApi(`${serverApi}${API_ALERTS}`, options);
  return item;
};

export const patchAlert = async (user, identifier, data) => {
  const { error, options } = setOptions(user, "PATCH", data);
  if (error) return { erros: error };
  const item = await fetchApi(
    `${serverApi}${API_ALERTS}${identifier}/`,
    options
  );
  return item;
};

export const patchDSSAlert = async (user, identifier, data) => {
  const { error, options } = setOptions(user, "PATCH", data);
  if (error) return { erros: error };
  const item = await fetchApi(
    `${serverApi}${API_DSSALERTS}${identifier}/`,
    options
  );
  return item;
};

export const patchInfo = async (user, identifier, data) => {
  const { error, options } = setOptions(user, "PATCH", data);
  if (error) return { erros: error };
  const item = await fetchApi(
    `${serverApi}${API_INFOS}${identifier}/`,
    options
  );
  return item;
};

export const detachAlert = (user, infoIdentifier, alertIdentifier) => {
  const { error, options } = setOptions(user, "DELETE");
  if (error) return { erros: error };
  return fetchApi(
    `${serverApi}${API_INFOS}${infoIdentifier}${API_ALERTS_DETACH}${alertIdentifier}`,
    options
  ).then(res => {
    return Promise.resolve("detached");
  })
    .catch(err => {
      return Promise.resolve({ status: 0, error: err.message });
    });
};

export const attachAlert = (user, info, alertIdentifier) => {
  const { error, options } = setOptions(user, "POST", info);
  if (error) return { erros: error };
  return fetchApi(
    `${serverApi}${API_INFOS}${info.identifier}${API_ALERTS_ATTACH}${alertIdentifier}`,
    options
  ).then(res => {
    return Promise.resolve("attached");
  })
    .catch(err => {
      return Promise.resolve({ status: 0, error: err.message });
    });
};


export const detachDSSAlert = (user, infoIdentifier, alertIdentifier) => {
  const { error, options } = setOptions(user, "DELETE");
  if (error) return { erros: error };
  return fetchApi(
    `${serverApi}${API_INFOS}${infoIdentifier}${API_DSSALERTS_DETACH}${alertIdentifier}`,
    options
  ).then(res => {
    return Promise.resolve("detached");
  })
    .catch(err => {
      return Promise.resolve({ status: 0, error: err.message });
    });
};

export const attachDSSAlert = (user, info, alertIdentifier) => {
  const { error, options } = setOptions(user, "POST", info);
  if (error) return { erros: error };
  return fetchApi(
    `${serverApi}${API_INFOS}${info.identifier}${API_DSSALERTS_ATTACH}${alertIdentifier}`,
    options
  ).then(res => {
    return Promise.resolve("attached");
  })
    .catch(err => {
      return Promise.resolve({ status: 0, error: err.message });
    });
};


export const postInfoAreas = async (user, identifier, data) => {
  const { error, options } = setOptions(user, "POST", data);
  if (error) return { erros: error };
  const item = await fetchApi(
    `${serverApi}${API_INFOS}${identifier}/areas/`,
    options
  );
  return item;
};

export const deleteInfoAreas = async (user, identifier, idArea) => {
  const { error, options } = setOptions(user, "DELETE");
  if (error) return { erros: error };
  const item = await fetchApi(
    `${serverApi}${API_INFOS}${identifier}/areas/${idArea}/`,
    options,
    true
  );
  return item;
};

export const postInfoResources = async (user, identifier, data) => {
  const { error, options } = setOptions(user, "POST", data);
  if (error) return { erros: error };
  const item = await fetchApi(
    `${serverApi}${API_INFOS}${identifier}/resources/`,
    options
  );
  return item;
};

export const patchInfoParameters = async (user, identifier, id, data) => {
  const { error, options } = setOptions(user, "PATCH", data);
  if (error) return { erros: error };
  const item = await fetchApi(
    `${serverApi}${API_INFOS}${identifier}/parameters/${id}/`,
    options
  );
  return item;
};

export const postInfoParameters = async (user, identifier, data) => {
  const { error, options } = setOptions(user, "POST", data);
  if (error) return { erros: error };
  const item = await fetchApi(
    `${serverApi}${API_INFOS}${identifier}/parameters/`,
    options
  );
  return item;
};

export const deleteInfoParameters = async (user, identifier, id) => {
  const { error, options } = setOptions(user, "DELETE");
  if (error) return { erros: error };
  const item = await fetchApi(
    `${serverApi}${API_INFOS}${identifier}/parameters/${id}/`,
    options,
    true
  );
  return item;
};

export const getOsmFromLatLon = async (user, osm_item) => {
  const { error, options } = setOptions(user);
  if (error) return { erros: error };
  const lat = osm_item.lat;
  const lon = osm_item.lon;
  const address = (osm_item && osm_item.address) || {}
  const isoKey = Object.keys(address).find(key=>key.startsWith("ISO3166"))
  const isoValue = isoKey ? address[isoKey] : null
  const countryCode = isoValue ? isoValue.slice(0, 2) : null;
  const url = `${serverApi}${API_OSM_SEARCH}?lat=${lat}&lon=${lon}${
    countryCode ? `&country_code=${countryCode}` : ""
  }`;
  const item = await fetchApi(url, options);
  return item;
};

export const patchInfoParameterArea = async (
  user,
  identifier,
  idParam,
  idFeature,
  data) => {
  const { error, options } = setOptions(user, "PATCH", data);
  if (error) return { erros: error };
  const item = await fetchApi(
    `${serverApi}${API_INFOS}${identifier}/parameters/${idParam}/areas/${idFeature}/`,
    options
  );
  return item;
};

export const postInfoParameterAreas = async (
  user,
  identifier,
  idParam,
  data
) => {
  const { error, options } = setOptions(user, "POST", data);
  if (error) return { erros: error };
  const item = await fetchApi(
    `${serverApi}${API_INFOS}${identifier}/parameters/${idParam}/areas/`,
    options
  );
  return item;
};

export const deleteInfoParameterAreas = async (
  user,
  identifier,
  id,
  idArea
) => {
  const { error, options } = setOptions(user, "DELETE");
  if (error) return { erros: error };
  const item = await fetchApi(
    `${serverApi}${API_INFOS}${identifier}/parameters/${id}/areas/${idArea}/`,
    options,
    true
  );
  return item;
};

export const getAlertbyIdentifier = async (user, identifier) => {
  const { error, options } = setOptions(user);
  if (error) return { erros: error };
  const item = await fetchApi(
    `${serverApi}${API_ALERTS}${identifier}/`,
    options
  );
  return item;
};

export const getInfobyIdentifier = async (user, identifier) => {
  const { error, options } = setOptions(user);
  if (error) return { erros: error };
  const item = await fetchApi(
    `${serverApi}${API_INFOS}${identifier}/`,
    options
  );
  return item;
};

export const getInfoGrouped = async (user, qparams = "?status=UN") => {
  const { error, options } = setOptions(user);
  if (error) return { erros: error };
  const item = await fetchApi(
    `${serverApi}${API_INFOS_GROUPED}${qparams}`,
    options
  );
  return item;
};

export const searchAlerts = async (user, queryString) => {
  const { error, options } = setOptions(user);
  if (error) return { erros: error };
  const items = await fetchApi(
    `${serverApi}${API_ALERTS}${queryString}`,
    options
  );
  return items;
};

export const searchInfos = async (user, queryString) => {
  const { error, options } = setOptions(user);
  if (error) return { erros: error };
  const items = await fetchApi(
    `${serverApi}${API_INFOS}${queryString}`,
    options
  );
  return items;
};

export const searchCountries = async (user, queryString) => {
  const { error, options } = setOptions(user);
  if (error) return { erros: error };
  const items = await fetchApi(
    `${serverApi}${API_AREA_COUNTRIES}${queryString}`,
    options
  );
  return items;
};

export const searchRegions = async (user, queryString) => {
  const { error, options } = setOptions(user);
  if (error) return { erros: error };
  const items = await fetchApi(
    `${serverApi}${API_AREA_REGIONS}${queryString}`,
    options
  );
  return items;
};

export const putInfoCountries = async (user, info_id, data) => {
  const { error, options } = setOptions(user, "PUT", data);
  if (error) return { erros: error };
  const response = await fetchApi(`${serverApi}${API_INFOS}${info_id}/update_countries/`, options);
  return response;
}


export const putInfoRegions = async (user, info_id, data) => {
  const { error, options } = setOptions(user, "PUT", data);
  if (error) return { erros: error };
  const response = await fetchApi(`${serverApi}${API_INFOS}${info_id}/update_regions/`, options);
  return response;
}

export const getReview = async user => {
  const { error, options } = setOptions(user);
  if (error) return { erros: error };
  const items = await fetchApi(`${serverApi}${API_INFO_TO_REVIEW}`, options);
  return items;
};

export const patchReview = async (user, id, info_id, data) => {
  const { error, options } = setOptions(user, "PATCH", data);
  if (error) return { erros: error };
  const items = await fetchApi(`${serverApi}${API_INFOS}${info_id}/reviews/${id}/`, options);
  return items;
};

const setOptions = (user, type = "GET", data = null) => {
  if (!user.auth) return { error: "no data, user not allowed" };
  const storedUser = getStoredUser();
  const accessToken =
    storedUser && storedUser.data
      ? storedUser.data.json_token
      : user.data.json_token;

  if (!accessToken) return { error: "no access token, user not allowed" };

  const options = {
    method: type,
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": CONTENT_TYPES.json,
      "Accept": "application/json",
      "Accept-Language": "en-US"
    }
  };
  if (data !== null) options.body = JSON.stringify(data);
  return { error: null, options };
};

const getStoredUser = () => {
  try {
    const currentUser = localStorage.getItem(KEY_CURRENT_USER);
    return currentUser ? JSON.parse(currentUser) : null;
  } catch (error) {
    return null;
  }
};

const getStoredAccessToken = () => {
  const user = getStoredUser();
  return user && user.data ? user.data.json_token : null;
};

const requestAccessToken = async () => {
  const user = getStoredUser();
  const refreshToken = user && user.data ? user.data.refresh_token : null;

  if (!refreshToken) return { accessToken: null, sessionExpired: true };

  try {
    const response = await fetch(`${serverApi}${API_AUTH_REFRESH}`, {
      method: "POST",
      headers: { "Content-Type": CONTENT_TYPES.json },
      body: JSON.stringify({ refresh: refreshToken })
    });
    const json = await response.json();
    const currentUser = getStoredUser();
    const currentRefreshToken =
      currentUser && currentUser.data
        ? currentUser.data.refresh_token
        : null;

    if (currentRefreshToken !== refreshToken) {
      return { accessToken: null, sessionExpired: false, cancelled: true };
    }

    if (response.ok && json.access) {
      currentUser.data.json_token = json.access;
      if (json.refresh) currentUser.data.refresh_token = json.refresh;
      localStorage.setItem(KEY_CURRENT_USER, JSON.stringify(currentUser));
      if (typeof refreshErrorHandler === "function") refreshErrorHandler(null);
      return { accessToken: json.access, sessionExpired: false };
    }

    const isSessionExpired =
      response.status === 400 ||
      response.status === 401 ||
      response.status === 403;
    const errorMessage =
      response.status === 429
        ? "Session renewal is temporarily busy. Please retry in a moment."
        : "Unable to renew your session. Please retry in a moment.";

    return {
      accessToken: null,
      sessionExpired: isSessionExpired,
      errorMessage
    };
  } catch (error) {
    return {
      accessToken: null,
      sessionExpired: false,
      errorMessage:
        "Unable to contact the server to renew your session. Check your connection and retry."
    };
  }
};

const refreshAccessToken = async failedAccessToken => {
  const storedAccessToken = getStoredAccessToken();

  if (storedAccessToken && storedAccessToken !== failedAccessToken) {
    if (typeof refreshErrorHandler === "function") refreshErrorHandler(null);
    return { accessToken: storedAccessToken, sessionExpired: false };
  }

  if (refreshPromise) return refreshPromise;

  refreshPromise = requestAccessToken();
  try {
    return await refreshPromise;
  } finally {
    refreshPromise = null;
  }
};

const isTokenAuthenticationError = (response, json) =>
  response.status === 401 ||
  (response.status === 403 && json && json.code === "token_not_valid");

/**
 * Description [Access Django Api get generic api]
 * @param {string} endpoint
 * @param {object} options
 * @return {object} django response
 */
const fetchApi = async (
  endpoint,
  options,
  returnStatus = false,
  hasRetried = false
) => {
  try {
    const response = await fetch(endpoint, options);
    let json = null;

    try {
      json = await response.json();
    } catch (error) {
      // Some successful operations, such as DELETE, may return an empty body.
    }

    const isAuthenticatedRequest =
      options && options.headers && options.headers.Authorization;

    if (
      isTokenAuthenticationError(response, json) &&
      isAuthenticatedRequest
    ) {
      if (!hasRetried) {
        const failedAccessToken = options.headers.Authorization.replace(
          "Bearer ",
          ""
        );
        const refreshResult = await refreshAccessToken(failedAccessToken);

        if (refreshResult.accessToken) {
          const retryOptions = {
            ...options,
            headers: {
              ...options.headers,
              Authorization: `Bearer ${refreshResult.accessToken}`
            }
          };
          return fetchApi(endpoint, retryOptions, returnStatus, true);
        }

        if (!refreshResult.sessionExpired) {
          if (refreshResult.cancelled) {
            if (returnStatus) return { status: response.status };
            return json === null ? {} : json;
          }

          if (typeof refreshErrorHandler === "function") {
            refreshErrorHandler(refreshResult.errorMessage);
          }
          if (returnStatus) {
            return {
              status: response.status,
              error: refreshResult.errorMessage
            };
          }
          return {
            error: refreshResult.errorMessage,
            code: "session_refresh_failed"
          };
        }
      }

      if (typeof unauthorizedHandler === "function") unauthorizedHandler();
    }

    if (returnStatus) return { status: response.status };
    return json === null ? {} : json;
  } catch (err) {
    if (returnStatus) return { status: 0, error: err.message };
    return { error: err.message };
  }
};
